// extracted by mini-css-extract-plugin
module.exports = {"disabled":"DropdownWidget_disabled__1U8oc","withFloatingLabel":"DropdownWidget_withFloatingLabel__3-V7s"};